import React, { Component } from 'react';
import ImageForm from './components/ImageForm';
import ImageAPI from './api/ImageAPI';
import ImageDisplay from './components/ImageDisplay';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: '',
            result: []
        }
    }

    getImages = async () => {
        let { query } = this.state;
        // let url = `/?query=${query}&client_id=${process.env.REACT_APP_IMAGE_API_KEY}`;
        const API_KEY = '3xScWMRR9pBdBdAstVZP7Y_8BLk4d-JlAF0waNOrIAA';
        let url = `/?query=${query}&client_id=${API_KEY}`;
        const response = await ImageAPI.get(url);
        // console.log(response);
        this.setState({
            result: response.data.results
        }, () => console.log(this.state.result));
    }

    handleChange = (e) => {
        // console.log(e.target.value)
        this.setState({
            query: e.target.value
        });
    }

    render() {
        return (
            <React.Fragment>
                <ImageForm
                    handleChange={this.handleChange}
                    query={this.state.query}
                    getImages={this.getImages}
                />
                <ImageDisplay result={this.state.result} />
            </React.Fragment>
        )
    }
}

export default App;